import React from 'react';
import SafeIcon from '../../../common/SafeIcon';
import { Icons } from '../../../shared/icons';

export default function PropertyStep({ 
  form, 
  setField,
  certificateType,
  client 
}) {
  const isLGSR = certificateType === 'lgsr';
  
  // Pre-fill from client data if available
  React.useEffect(() => {
    if (client && !form.property_address) {
      const clientAddress = [client.address_line1, client.address_line2, client.city, client.postcode, client.country]
        .filter(Boolean)
        .join(', ');
      if (clientAddress) {
        setField('property_address', clientAddress);
      }
    }
  }, [client, form.property_address, setField]);

  return (
    <div className="property-step">
      <label className="cert-field">
        Property Address
        <textarea
          value={form.property_address}
          onChange={(e) => setField('property_address', e.target.value)}
          placeholder="Full property address"
          rows={3}
          required
          aria-label="Property address"
        />
      </label>

      {isLGSR && (
        <>
          <label className="cert-field">
            Landlord Name
            <input
              type="text"
              value={form.landlord_name}
              onChange={(e) => setField('landlord_name', e.target.value)}
              placeholder="Landlord or homeowner name"
              required
              aria-label="Landlord name"
            />
          </label>

          <label className="cert-field">
            Landlord/Agent Details
            <input
              type="text"
              value={form.landlord_agent}
              onChange={(e) => setField('landlord_agent', e.target.value)}
              placeholder="Name and address of landlord or managing agent"
              aria-label="Landlord or agent details"
            />
          </label>
        </>
      )}

      <label className="cert-field">
        Check Date
        <input
          type="date"
          value={form.check_date}
          onChange={(e) => setField('check_date', e.target.value)}
          required
          aria-label="Check or inspection date"
        />
      </label>

      <p className="field-hint">
        <SafeIcon icon={Icons.Info} size={14} />
        Property details are recorded on the certificate for compliance purposes
      </p>
    </div>
  );
}